"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersection = void 0;
function intersection(array1, array2) {
    return array1.filter(value => array2.includes(value));
}
exports.intersection = intersection;
//# sourceMappingURL=intersection.js.map